import { Region } from '@lemon8/web-app-shared/i18n';

export const CAMPAIGN_ID = 'referral_2024';

export const sslocal =
  'sslocal://webview?url=https%3A%2F%2Flf16-sourcecdn-tos.ibytedtos.com%2Fobj%2Fbyte-gurd-source-sg%2F62%2Fgecko%2Fresource%2Freferral_gifts%2Fhtml%2Fhome.html%3Fposition%3Dreflow_page&bdhm_bid=lemon8_activity&bdhm_pid=refferal_2024&hide_navigation_bar=1&allow_change_statusbar=1&fontStable=1&disable_bounces=1';

export const snssdk2657 = sslocal.replace('sslocal', 'snssdk2657');

export const ImageRegion: any = {
  [Region.jp]: 'https://p16-va.topbuzzcdn.com/origin/tos-maliva-i-2014-us/681ee3c1a3d94c8cbe3a7756d5dc5847',
  [Region.th]: 'https://p16.topbuzzcdn.com/origin/tos-alisg-i-2014-sg/20a8b71a056048ea96a77297a89d23b9',
  default: 'https://p16-va.topbuzzcdn.com/origin/tos-maliva-i-2014-us/681ee3c1a3d94c8cbe3a7756d5dc5847',
};
